import type { JSX, PropsWithChildren, ReactNode } from 'react';
import type { Moment } from 'moment/moment';

import DeprecatedDateRangePicker from './components/datepicker/DateRangePicker';

export type DateRangePickerCustomPresets = {
    startValue: Moment;
    endValue: Moment;
    text: string | JSX.Element;
    onSelect?: Function;
};

export type DateRangePickerProps = {
    startValue?: Moment;
    endValue?: Moment;
    defaultStartValue?: Moment;
    defaultEndValue?: Moment;
    minValue?: Moment | null;
    maxValue?: Moment | null;
    onRangeChange?: (start: Moment, end: Moment) => void;
    locale: string;
    textDefault?: string | ReactNode;
    textToday?: string | ReactNode;
    textLastWeek?: string | ReactNode;
    textLastMonth?: string | ReactNode;
    textLastYear?: string | ReactNode;
    textCustom?: string | ReactNode;
    textApply?: string | ReactNode;
    textCancel?: string | ReactNode;
    textFrom?: string | ReactNode;
    textTo?: string | ReactNode;
    className?: string;
    dropdownClass?: string;
    dropdownMenuClass?: string;
    hasTimePicker?: boolean;
    customRangeOnly?: boolean;
    customPresets?: DateRangePickerCustomPresets[];
    dropup?: boolean;
    pullRight?: boolean;
    autoDropDirection?: boolean;
};

/**
 * Wrapper component for React-Datetime.
 *
 * @deprecated This will be removed from the UIKIT at some time.
 */
export const DateRangePicker = (props: PropsWithChildren<DateRangePickerProps>) => {
    const { children, ...remainingProps } = props;
    return <DeprecatedDateRangePicker {...remainingProps}>{children}</DeprecatedDateRangePicker>;
};
